import { Injectable } from "@angular/core";
import { PromiseBlotterLookupService } from "../../impl/PromiseBlotterLookupService";
import { IOpsIntPromiseLookupService } from "../IOpsIntPromiseLookupService";
import { IMarketTimePromiseLookupService } from "../IMarketTimePromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { OpsIntLookupService } from "./OpsIntLookupService";

export abstract class OpsIntPromiseLookupService
  extends PromiseBlotterLookupService<string, CubiqTS.OpsIntEventImpl>
  implements IOpsIntPromiseLookupService
{
  constructor(protected base: OpsIntLookupService) {
    super();
  }

  abstract getFilterCategoryTypes(): Promise<Map<string, CubiqTS.OpsFiltCategoryType>>;
}
